import React from 'react';

import { MediaCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './SectionsHero.styles';

export interface SectionsHeroProps {
  media: MediaCMS;
}

const defaultProps: Partial<SectionsHeroProps> = {};

const SectionsHero: React.FunctionComponent<SectionsHeroProps> = ({
  media,
}) => {
  return <S.SectionsHeroWrapper url={media[0].url} />;
};

SectionsHero.defaultProps = defaultProps;

export default SectionsHero;
